<template>
    <q-page padding>
        <div class="q-display-1 q-mb-md text-secondary">
            <q-icon name="fas fa-store" class="q-mb-sm" /> Produto
        </div>

        <q-tabs v-model="tab">
            <q-tab slot="title" name="basic-data" :label="$t('basic_data')" />
            <q-tab slot="title" name="vouchers" :label="$t('vouchers')" v-show="showTabVouchers" />

            <q-tab-pane name="basic-data">
                <basic-data @set_reward_product_type="setRewardProductType" />
            </q-tab-pane>

            <q-tab-pane name="vouchers" keep-alive>
                <vouchers :reward_id="reward_id" />
            </q-tab-pane>
        </q-tabs>
    </q-page>
</template>

<script>
import BasicData from 'components/admin/rewards/BasicData'
import Vouchers from 'components/admin/rewards/Vouchers'

export default {
    i18nOptions: { namespaces: ['common', 'rewards', 'admin'] },

    data() {
        return {
            tab: 'basic-data',
            reward_id: 0,
            reward_product_type: null
        }
    },

    computed: {
        showTabVouchers() {
            if (this.reward_id != 0 && this.reward_product_type === 'voucher') return true
            else return false
        }
    },

    methods: {
        setRewardProductType(has) {
            this.reward_product_type = has
        }
    },

    components: {
        'basic-data': BasicData,
        'vouchers': Vouchers,
    },

    watch: {
        '$route': function () {
            this.reward_id = this.$route.params.id
        }
    },

    created() {
        this.reward_id = this.$route.params.id
    }
}
</script>

<style></style>
